/**
 * Badge "X/Y · N restantes" reutilizable para mostrar consumo de cap.
 * Cambia de color según severidad (verde → amarillo → rojo).
 */
import { AlertTriangle } from 'lucide-react';

export default function UsageBadge({ status, label, suffix = '', testId }) {
  if (!status) return null;
  if (status.unlimited) {
    return (
      <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-[11px]" data-testid={testId}>
        <span className="text-emerald-300">{label}: ilimitado</span>
      </div>
    );
  }
  const pct = status.max > 0 ? (status.current / status.max) * 100 : 0;
  const tone =
    status.exceeded || pct >= 100 ? 'rose'
    : pct >= 85 ? 'amber'
    : 'emerald';
  const cls = {
    rose: 'bg-rose-500/10 border-rose-500/20 text-rose-300',
    amber: 'bg-amber-500/10 border-amber-500/20 text-amber-300',
    emerald: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-300',
  }[tone];
  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] ${cls}`} data-testid={testId}>
      {(tone === 'amber' || tone === 'rose') && <AlertTriangle className="w-3 h-3" />}
      <span className="font-medium">{label}: {status.current}/{status.max}{suffix}</span>
      {!status.exceeded && <span className="opacity-70">· {status.remaining} restantes</span>}
      {status.exceeded && <span className="font-bold">· cupo agotado</span>}
    </div>
  );
}
